<template>
    <rkm-area
        :subtitle="subtitle"
        title="Fatores de risco"
        type="fieldset"
    >
        <Form :data="data" />
    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    computed: {
        subtitle() {
            if (this.data.form.dataHora) {
                return this.data.form.dataHora.concat(
                    ' | ',
                    this.data.form.lotacao.profissional.nome
                )
            } else {
                return ''
            }
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>